import React from 'react';

const InfoModal = ({ isOpen, onClose, title, icon, children }) => {
    // Si tienes un estado para controlar si se muestra o no
    if (!isOpen) return null;

    return (
        <div className="modal-wrapper" onClick={onClose}>
            {/* stopPropagation evita que el modal se cierre al hacer clic dentro de la tarjeta */}
            <div className="modal-card" onClick={(e) => e.stopPropagation()}>

                <button className="modal-close" onClick={onClose} >
                    <i className='icon icon_enlinea_error'></i>
                </button>
                
                {icon && (
                    <div className="box-icon">
                        <i className={`icon ${icon}`}></i>
                    </div>
                )}
                

                <h2 className="modal-title">{title}</h2>

                <div className="modal-content">
                    {children}
                </div>

            </div>
        </div>
    );
};

export {InfoModal};